module.exports = __webpack_public_path__ + "static/media/step2.a95fe0f1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/step2.mp4
// module id = 241
// module chunks = 8